import React from "react";
import CalendarHeatmap from "react-calendar-heatmap";
import moment from "moment";
import "react-calendar-heatmap/dist/styles.css";

const HeatMap = () => {
  const values = [
    { date: "2021-10-01", count: 1 },
    { date: "2021-10-04", count: 4 },
    { date: "2021-10-07", count: 2 },
    { date: "2021-10-18", count: 6 },
    { date: "2021-10-29", count: 3 },
    // more values...
  ];

  const startDate = moment("2021-10-01").toDate();
  const endDate = moment("2021-10-31").toDate();

  return (
    <div>
      <h3 style={{ textAlign: "center" }}>October 2021</h3>
      <CalendarHeatmap
        startDate={startDate}
        endDate={endDate}
        values={values}
        classForValue={(value) => {
          if (!value || !value.count) return "color-empty";
          if (value.count >= 6) return "color-scale-4";
          if (value.count >= 4) return "color-scale-3";
          if (value.count >= 2) return "color-scale-2";
          return "color-scale-1";
        }}
        tooltipDataAttrs={(value) => {
          if (!value || !value.date) return null;
          return {
            "data-tip": `${moment(value.date).format("MMM DD, YYYY")} has ${value.count} entries`,
          };
        }}
        showWeekdayLabels
      />
    </div>
  );
};

export default HeatMap;
